// extracted by mini-css-extract-plugin
module.exports = {"root":"gxoo2lVnyZYi","header":"_2DDUKwuNxlb6","footer":"EqOHg8c2P4am","checkedInIcon":"ASsmZgtIzyLz"};